import { render } from "./LogInfo.vue?vue&type=template&id=6e9945c0&ts=true"
import script from "./LogInfo.vue?vue&type=script&lang=ts"
export * from "./LogInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/cibweb-v2-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__